import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  ModalController,
  Platform,
  IonContent,
  LoadingController,
} from '@ionic/angular';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Router } from '@angular/router';

import { Stylist } from '../../models/stylist/stylist.model';
import { Country } from '../../models/country/country.model';
import { Salon } from '../../models';
import { StylistService } from '../../services/stylist.service';
import { UserService } from '../../services/user.service';
import { CountryService } from '../../services/country.service';
import { CustomValidator } from '../../utilities/custom-validator';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import { StylistChangePasswordFormComponent } from '../../components/stylist-change-password-form/stylist-change-password-form.component';
import { NavigationStateService } from 'src/app/services/navigation-state.service';
@Component({
  selector: 'smr-stylist-profile',
  templateUrl: './stylist-profile.page.html',
  styleUrls: ['./stylist-profile.page.scss'],
})
export class StylistProfilePage implements OnInit, OnDestroy {
  @ViewChild('imageUploadInput') imageUploadInput;

  @ViewChild(IonContent) content: IonContent;

  public isLoading: boolean;

  public isImageLoading: boolean = false;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public submitAttempt: boolean;

  public stylistID: number;

  public stylist: Stylist;
  public salon: Salon;
  public readOnlyStylistPicker: boolean;

  public stylistProfileForm: UntypedFormGroup;

  public firstName: UntypedFormControl;

  public lastName: UntypedFormControl;
  public title: UntypedFormControl;

  public email: UntypedFormControl;

  public phone1: UntypedFormControl;

  public phone2: UntypedFormControl;

  public address1: UntypedFormControl;

  public address2: UntypedFormControl;

  public city: UntypedFormControl;

  public province: UntypedFormControl;

  public postal: UntypedFormControl;

  public country: UntypedFormControl;

  public active: UntypedFormControl;

  public administrator: UntypedFormControl;

  public hasCalendar: UntypedFormControl;

  public canEditOwnSettings: UntypedFormControl;

  public canViewAllClients: UntypedFormControl;

  public canViewAllStaffCalendars: UntypedFormControl;

  public canViewAllReports: UntypedFormControl;

  public canReceivePushNotificaitons: UntypedFormControl;
  public pronouns: UntypedFormControl;
  public customPronouns: UntypedFormControl;
  public pronounOptions: List<{ name: string; value: number }>;
  public photo: UntypedFormControl;

  public countries: List<Country>;

  public tab: string;

  public isMobile: boolean;

  public defaultStylistPhoto: string;

  public callBack;

  public isEditingMyProfile: boolean;

  public isUserAdmin: number;

  public stylistsWithCalendarNum: number;

  public user;

  public navigationStateSubscription

  constructor(
    private alertCtrl: AlertController,
    private countryService: CountryService,
    private stylistService: StylistService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private modalCtrl: ModalController,
    private platform: Platform,
    //private loadingCtrl: LoadingController,
    private actionSheetController: ActionSheetController,
    private readonly alertService: AlertService,
    private readonly toastService: ToastService,
    private router: Router,
    private loadingCtrl: LoadingController,
    private navigationStateService: NavigationStateService
  ) {
    this.isLoading = true;
    this.submitAttempt = false;
    this.countries = List([]);
    this.pronounOptions = List.of(
      {
        name: 'Please select',
        value: 0,
      },
      {
        name: 'She/Her',
        value: 1,
      },
      {
        name: 'He/Him',
        value: 2,
      },
      {
        name: 'They/Them',
        value: 3,
      },
      {
        name: 'Custom',
        value: 4,
      }
    );

    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.stylistID = state.stylistID;
      this.callBack = state.callBack;
    });
    const user = this.userService.getUser();
    this.user = user;
    //this.stylistID = this.navParams.get('stylistID') ?  this.navParams.get('stylistID') : user.getID();
    //this.callBack = this.navParams.get('callBack');

    if (user.isAdministrator()) {
      this.readOnlyStylistPicker = false;
    } else {
      this.readOnlyStylistPicker = true;
    }

    this.firstName = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(30)])
    );
    this.lastName = new UntypedFormControl('', Validators.maxLength(35));
    this.title = new UntypedFormControl('', Validators.maxLength(35));

    this.salon = userService.getSalon().clone();
    const countryID = this.salon.getCountry().id;
    this.pronouns = new UntypedFormControl(user ? user.getPronoun() : '0');
    this.customPronouns = new UntypedFormControl(
      user.getCustomPronoun(),
      Validators.maxLength(35)
    );

    this.stylistService.setEmailCheckerStylistID(this.stylistID);
    this.email = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.maxLength(100),
        CustomValidator.validateEmail,
      ])
    );
    this.phone1 = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.maxLength(20),
        CustomValidator.validatePhone(countryID),
      ])
    );
    this.phone2 = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.maxLength(20),
        CustomValidator.validatePhone(countryID),
      ])
    );
    this.address1 = new UntypedFormControl('', Validators.maxLength(40));
    this.address2 = new UntypedFormControl('', Validators.maxLength(40));
    this.city = new UntypedFormControl('', Validators.maxLength(20));
    this.province = new UntypedFormControl('', Validators.maxLength(25));
    this.postal = new UntypedFormControl('', Validators.maxLength(25));
    this.active = new UntypedFormControl(false);
    this.administrator = new UntypedFormControl(false);
    this.hasCalendar = new UntypedFormControl(false);
    this.canEditOwnSettings = new UntypedFormControl(false);
    this.canViewAllClients = new UntypedFormControl(false);
    this.canViewAllStaffCalendars = new UntypedFormControl(false);
    this.canViewAllReports = new UntypedFormControl(false);
    this.canReceivePushNotificaitons = new UntypedFormControl(false);
    this.photo = new UntypedFormControl();
    //this.country = new FormControl(null);
    this.country = new UntypedFormControl(
      '',
      Validators.compose([Validators.required])
    );
    this.stylistProfileForm = this.formBuilder.group({
      firstName: this.firstName,
      lastName: this.lastName,
      title: this.title,
      email: this.email,
      phone1: this.phone1,
      phone2: this.phone2,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal: this.postal,
      country: this.country,
      active: this.active,
      administrator: this.administrator,
      hasCalendar: this.hasCalendar,
      canEditOwnSettings: this.canEditOwnSettings,
      canViewAllClients: this.canViewAllClients,
      canViewAllStaffCalendars: this.canViewAllStaffCalendars,
      canViewAllReports: this.canViewAllReports,
      canReceivePushNotificaitons: this.canReceivePushNotificaitons,
      photo: this.photo,
      pronoun: this.pronouns,
      customPronoun: this.customPronouns,
    });

    this.tab = 'stylist-details';
    this.defaultStylistPhoto = Stylist.getDefaultProfilePic();
  }

  public ngOnInit() {
    this.platform.ready().then(() => {
      if (
        this.platform.is('mobile') ||
        this.platform.is('android') ||
        this.platform.is('iphone') ||
        this.platform.is('mobileweb')
      ) {
        this.isMobile = true;
      }
    });
    this.stylistService.setOutdated();
    this.stylistService.loadStylistInfo(this.stylistID).subscribe((stylist) => {
      this.stylist = stylist;
      this.onStylistSelect();
    });
    this.countryService.getCountries().subscribe({
      next: (countries) => {
        this.countries = countries;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.presentErrorAlert();
      },
    });
    this.stylistService.getStylists().subscribe({
      next: (stylists) => {
        this.stylistsWithCalendarNum = stylists
          .filter((stylist) => stylist.active == 1 && stylist.calendar == 1)
          .count();
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.presentErrorAlert();
      },
    });
  }

    
  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public onAdminToggleChange(toggleVal): void {
    const isChecked = toggleVal.detail.checked;
    if (isChecked === true) {
      this.canEditOwnSettings.setValue(true);
      this.canViewAllClients.setValue(true);
      this.canViewAllStaffCalendars.setValue(true);
      this.canViewAllReports.setValue(true);
      this.canReceivePushNotificaitons.setValue(true);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
  }

  public onStylistSelect() {
    this.isLoading = false;

    this.isEditingMyProfile =
      this.userService.getUser().getID() == this.stylist.getID();
    this.isUserAdmin = this.userService.getUser().administrator;

    this.firstName.setValue(this.stylist.getFirstName());
    this.lastName.setValue(this.stylist.getLastName());
    this.title.setValue(this.stylist.getTitle());
    this.email.setValue(this.stylist.getEmail());
    this.phone1.setValue(this.stylist.getPhone1());
    this.phone2.setValue(this.stylist.getPhone2());
    this.address1.setValue(this.stylist.getAddress1());
    this.address2.setValue(this.stylist.getAddress2());
    this.city.setValue(this.stylist.getCity());
    this.province.setValue(this.stylist.getProvince());
    this.postal.setValue(this.stylist.getPostal());
    this.pronouns.setValue(this.stylist.getPronoun());
    this.customPronouns.setValue(this.stylist.getCustomPronoun());
    this.country.setValue(
      this.stylist.getCountry() !== undefined
        ? this.stylist.getCountry().getID()
        : this.userService.getSalon().getCountry !== undefined
        ? this.userService.getSalon().getCountry
        : null
    );

    // permissions
    this.disableAllPermissionSettings();

    this.active.setValue(this.stylist.active === 1);
    this.administrator.setValue(this.stylist.administrator === 1);
    this.hasCalendar.setValue(this.stylist.calendar === 1);
    this.canEditOwnSettings.setValue(this.stylist.settingsControl === 1);
    this.canViewAllClients.setValue(this.stylist.viewAllClients === 1);
    this.canViewAllStaffCalendars.setValue(this.stylist.viewAllCalendars === 1);
    this.canViewAllReports.setValue(this.stylist.canViewReports === 1);
    this.canReceivePushNotificaitons.setValue(this.stylist.canPush === 1);

    // appply the restrictions based on the settings
    const isAdmin: boolean = this.userService.getUser().isAdministrator();
    const allowedToEditMyOwnSettings: boolean =
      this.userService.getUser().getSettingsControl() === 1;

    if (isAdmin) {
      if (this.isEditingMyProfile) {
        this.hasCalendar.enable();
        this.canEditOwnSettings.enable();
        this.canViewAllClients.enable();
        this.canViewAllStaffCalendars.enable();
        this.canViewAllReports.enable();
        this.canReceivePushNotificaitons.enable();
        this.hasCalendar.enable();
        this.canViewAllClients.enable();
      } else {
        this.enableAllPermissionSettings();
      }
    } else {
      if (this.isEditingMyProfile && allowedToEditMyOwnSettings) {
        this.canReceivePushNotificaitons.enable();
      }
    }

    // this.content.resize();
  }

  public isAllowedToAddStaffMember(): boolean {
    const planID: number = this.userService.getSalon().getPlanID();

    if ((planID === 2 || planID === 7) && this.stylistsWithCalendarNum < 1) {
      // freeplan || solo plan with 1 staff member
      return true;
    } else if (
      (planID === 3 || planID === 8) &&
      this.stylistsWithCalendarNum < 5
    ) {
      // small plan with 2 - 5 staff members
      return true;
    } else if (
      (planID === 4 || planID === 9) &&
      this.stylistsWithCalendarNum < 10
    ) {
      // medium plan with 6 - 10 staff members
      return true;
    } else if (planID === 5 || planID === 6 || planID === 10) {
      // large plan with unlimited staff
      return true;
    } else {
      return false;
    }
  }

  public onActiveChange() {
    if (
      !this.isAllowedToAddStaffMember() &&
      this.active.value == 1 &&
      this.hasCalendar.value == 1
    ) {
      this.alertService.presentErrorAlert(
        'Your account has reached its maximum staff limit. You can upgrade your plan to add another staff member.'
      );
      this.active.setValue(0);
      this.hasCalendar.setValue(0);
    }
  }

  public enableAllPermissionSettings() {
    this.active.enable();
    this.administrator.enable();
    this.hasCalendar.enable();
    this.canEditOwnSettings.enable();
    this.canViewAllClients.enable();
    this.canViewAllStaffCalendars.enable();
    this.canViewAllReports.enable();
    this.canReceivePushNotificaitons.enable();
  }

  public disableAllPermissionSettings() {
    this.active.disable();
    this.administrator.disable();
    this.hasCalendar.disable();
    this.canEditOwnSettings.disable();
    this.canViewAllClients.disable();
    this.canViewAllStaffCalendars.disable();
    this.canViewAllReports.disable();
    this.canReceivePushNotificaitons.disable();
  }

  public async onStylistFormSave() {
    this.submitAttempt = true;
    if (this.stylistProfileForm.valid === false) {
      return;
    }

    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });

    loader.present();

    let newCountry: Country = this.countries
      .filter(
        (country: Country) =>
          country.getID() === parseInt(this.country.value, 10)
      )
      .first();
    this.stylist = this.stylist.setFirstName(this.firstName.value);
    this.stylist = this.stylist.setLastName(this.lastName.value);
    this.stylist = this.stylist.setTitle(this.title.value);
    this.stylist = this.stylist.setEmail(this.email.value);
    this.stylist = this.stylist.setPhone1(this.phone1.value);
    this.stylist = this.stylist.setPhone2(this.phone2.value);
    this.stylist = this.stylist.setAddress1(this.address1.value);
    this.stylist = this.stylist.setAddress2(this.address2.value);
    this.stylist = this.stylist.setCity(this.city.value);
    this.stylist = this.stylist.setProvince(this.province.value);
    this.stylist = this.stylist.setPostal(this.postal.value);
    this.stylist = this.stylist.setCountry(newCountry);
    this.stylist = this.stylist.setPronoun(this.pronouns.value);
    this.stylist = this.stylist.setCustomPronoun(this.customPronouns.value);

    this.stylist = this.stylist.setActive(this.active.value ? 1 : 0);
    this.stylist = this.stylist.setadministrator(this.administrator.value);
    this.stylist = this.stylist.setCalendar(this.hasCalendar.value ? 1 : 0);
    this.stylist = this.stylist.setSettingsControl(
      this.canEditOwnSettings.value ? 1 : 0
    );
    this.stylist = this.stylist.setViewAllClients(
      this.canViewAllClients.value ? 1 : 0
    );
    this.stylist = this.stylist.setViewAllCalendars(
      this.canViewAllStaffCalendars.value ? 1 : 0
    );
    this.stylist = this.stylist.setCanViewReports(
      this.canViewAllReports.value ? 1 : 0
    );
    this.stylist = this.stylist.setCanPush(
      this.canReceivePushNotificaitons.value ? 1 : 0
    );
    this.stylistService.saveStylist(this.stylist).subscribe({
      next: (stylist) => {
        this.stylistService.updateStylist(this.stylist);
        loader.dismiss().then(() => {
          if (this.callBack) {
            this.callBack(stylist);
          }
          this.toastService.presentSimpleToast(
            `Staff info has been successfully updated.`,
            3000
          );
          //this.navCtrl.pop();
          this.router.navigateByUrl('settings/stylist-manager');
        });
      },
      error: (error) => {
        loader.dismiss();
      },
      complete: () => console.info('Fetched all stylists'),
    });
  }

  public async onStylistDelete() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Are you sure you want to delete this staff?',
      buttons: [
        {
          text: 'Delete',
          role: 'destructive',
          handler: async () => {
            const loader = await this.loadingCtrl.create({
              spinner: 'crescent',
            });

            this.stylistService.deleteStylist(this.stylist).subscribe(
              (result) => {
                loader.dismiss().then(() => {
                  if (this.callBack) {
                    this.callBack(this.stylist);
                  }

                  this.toastService.presentSimpleToast(
                    `Staff has been successfully deleted.`,
                    3000
                  );
                  //this.navCtrl.pop();
                  this.router.navigateByUrl('settings/stylist-manager');
                });
              },
              (error) => {
                loader.dismiss().then(() => {
                  this.alertService.presentErrorAlert();
                });
              }
            );
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {},
        },
      ],
    });

    await actionSheet.present();
  }

  public async onChangePassword() {
    //this.modalCtrl.create("StylistChangePasswordFormPage", {stylist: this.stylist}).present();
    const modal = await this.modalCtrl.create({
      component: StylistChangePasswordFormComponent,
      componentProps: {
        stylist: this.stylist,
      },
    });
    modal.present();
  }

  public changeProfilePhotoWeb() {
    this.imageUploadInput.nativeElement.click();
  }

  public onImageUploadInputChange($event): void {
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    this.isImageLoading = true;
    myReader.onloadend = async (e) => {
      //const base64Image = <string>myReader.result;
      const base64Image = myReader.result as string;
      this.stylistService
        .changePhoto(this.stylist, base64Image)

        .subscribe({
          next: (stylist) => {
            this.stylist = stylist;
            if (this.stylist.id === this.user.id) {
              this.userService.updateProfileImg(stylist.photoUrl)
            }
            this.toastService.presentSimpleToast(
              'Stylist photo has been successfully updated',
              3000
            );
            this.isImageLoading = false;
          },
          error: (error) => {
            this.isImageLoading = false;
            this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig());
          },
        });
    };

    myReader.readAsDataURL(file);
  }

  public async onNativeChangePhoto() {
    if (this.isMobile) {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: CameraSource.Prompt
      });
      // image.webPath will contain a path that can be set as an image src.
      // You can access the original file using image.path, which can be
      // passed to the Filesystem API to read the raw data of the image,
      // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
      var imageUrl = image.base64String;

      // Can be set to the src of an image now
      const base64Image = 'data:image/jpeg;base64,' + imageUrl;
      this.isImageLoading = true;

      this.stylistService.changePhoto(this.stylist, base64Image).subscribe({
        next: (stylist) => {
            this.stylistService.setStylist(stylist);
            this.stylist = stylist;
            if (this.stylist.id === this.user.id) {
              this.userService.updateProfileImg(stylist.photoUrl)
            }
            this.toastService.presentSimpleToast(
              'Stylist photo has been successfully updated',
              3000
            );
            this.isImageLoading = false;
        },
        error: (error) => {
            this.alertService.presentErrorAlert();
            this.isImageLoading = false;
        },
        //complete: () => console.info('Fetched all stylists')
      });
    }
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('settings');
  }
}
